// extracted by css-extract-rspack-plugin
export default {"container":"container-PM2N2z"};